<template>
	<transition name="fade">
		<div
			v-if="active"
			class="loading-overlay"
			:class="{ 'loading-overlay--full': isFullPage }"
			aria-busy="true"
			aria-label="Loading"
		>
			<div class="loading-overlay__backdrop" />
			<div class="loading-overlay__content">
				<OvBusySpinner :size="isFullPage ? 64 : 40" />
			</div>
		</div>
	</transition>
</template>

<script>
import OvBusySpinner from "./OvBusySpinner.vue";

export default {
	name: "LoadingOverlay",
	components: { OvBusySpinner },
	props: {
		active: { type: Boolean, default: false },
		isFullPage: { type: Boolean, default: false },
		skeleton: { type: Boolean, default: false },
		skeletonRows: { type: Number, default: 8 },
	},
};
</script>

<style lang="scss" scoped>
.loading-overlay {
	position: absolute;
	inset: 0;
	z-index: 50;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	border-radius: inherit;

	&--full {
		position: fixed;
		inset: 0;
		z-index: 999;
		border-radius: 0;
	}

	&__backdrop {
		position: absolute;
		inset: 0;
		background: #fff;
		opacity: 0.5;
	}

	&__content {
		position: relative;
		z-index: 1;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}
</style>
